import { DataView } from "primereact/dataview";
import React, { useState } from "react";
import ImageButton from "../buttons/ImageButton";
import { Col, Row } from "react-bootstrap";
import downloadIcon from './../../assets/images/downloadIcon.png'
import downloadIconFocus from './../../assets/images/downloadIconFocus.png'
import deleteIcon from '../../assets/images/delete.png'
import deleteIconFocus from '../../assets/images/delete-orange.png'
import { deleteAsset, downloadAsset, uploadAsset } from "../../assets/assetsSlice";
import { useDispatch, useSelector } from "react-redux";
import { showSuccessToast, showErrorToast } from "../../app/utils/helpers";
import Langs from "../../app/lang/langs";
import { MobileAssetsPannel } from "./MobileAssetsPannel";
import { ConfirmDeleteModal } from "../popups/ConfirmDeleteModal";

export function AssetsPannel(props) {
    const dispatch = useDispatch();
    const isMobile = useSelector((state) => state.settings.isMobile);
    const [assetToDelete, setAssetToDelete] = useState(null);

    if (isMobile === 2 || isMobile === 3) {
        return <MobileAssetsPannel {...props} />;
    }

    const handleDeleteConfirmed = () => {
        if (!assetToDelete) return;
        dispatch(
            deleteAsset({
                tableName: assetToDelete.table_name,
                idParent: assetToDelete.id_parent,
                filename: assetToDelete.filename,
            })
        ).then((actionResponse) => {
            if (deleteAsset.fulfilled.match(actionResponse)) {
                showSuccessToast('Fichier supprimé avec succès');
                if (props.parentSetter) {
                    props.parentSetter((prev) => ({
                        ...prev,
                        assets: prev.assets.filter((a) => a.filename !== assetToDelete.filename)
                    }));
                }
                props.deleteCallBackFunction();
            }
        }).catch((error) => {
            console.error('Error handling in deleteAsset:', error);
        });
        setAssetToDelete(null);
    };

    const assetTemplate = (asset, index) => {
        return (
            <Row className='py-2' style={{ borderBottom: "1px #D9D9D9 solid" }}>
                <Col lg={10}>
                    {asset.filename}
                </Col>
                <Col lg={1}>
                    <ImageButton
                        onClick={() => dispatch(downloadAsset({
                            tableName: asset.table_name,
                            idParent: asset.id_parent,
                            filename: asset.filename,
                        }))}
                        image={downloadIcon}
                        imageFocus={downloadIconFocus}
                        active={true}
                        width={22}
                    />
                </Col>
                <Col lg={1}>
                    {!props.readOnly && (
                        <ImageButton
                            onClick={() => setAssetToDelete(asset)}
                            image={deleteIcon}
                            imageFocus={deleteIconFocus}
                            active={true}
                            width={22}
                        />
                    )}
                </Col>
            </Row>
        )
    }

    const assetListTemplate = (items) => {
        if (!items || items.length === 0) return null;
        return <div className="grid grid-nogutter">{items.map((asset, index) => assetTemplate(asset, index))}</div>;
    };

    const uploadAssetTemplate = (file, idParent, tableName) => {
        if (!file) return;
        const filename = file.name;
        if (!idParent || !tableName) {
            showErrorToast('Erreur lors de l\'envoi du fichier');
            return;
        }
        dispatch(uploadAsset({ file, tableName, idParent, filename }))
            .then((actionResponse) => {
                if (uploadAsset.fulfilled.match(actionResponse)) {
                    if (props.parentSetter) {
                        let assetTemp = { filename, table_name: tableName, id_parent: idParent };
                        props.parentSetter((prev) => ({
                            ...prev,
                            assets: [...(prev.assets || []), assetTemp]
                        }));
                    }
                    props.uploadCallBackFunction();
                }
            })
            .catch((error) => {
                console.error('Error handling in uploadAsset:', error);
            });
    }

    const isLimitReached = props.limitLength
        ? Array.isArray(props.assets) && (props.assets.length >= props.limitLength)
        : false;

    return (
        <div>
            <Row>
                <Col lg={12} className="mb-3 pe-3 p-fluid align-items-center border-top pt-3 mt-3">
                    <h3>
                        <Langs str={props.label} />
                    </h3>
                </Col>
                <Col lg={12} className="mb-3 pe-3 p-fluid">
                    <div>
                        <DataView
                            value={props.assets || []}
                            listTemplate={assetListTemplate}
                            paginator
                            paginatorPosition="top"
                            rows={5}
                            className="card p-2"
                            style={{ height: "340px", width: "100%" }}
                        />
                        {!isLimitReached && !props.readOnly && (
                            <input
                                className="form-control"
                                type="file"
                                id="formFile"
                                onChange={(e) => {
                                    uploadAssetTemplate(e.target.files[0], props.idParent, props.tableName)
                                    e.target.value = null
                                }}
                                style={{ marginTop: '10px' }}
                            />
                        )}
                    </div>
                </Col>
            </Row>
            <ConfirmDeleteModal
                show={!!assetToDelete}
                title={<Langs str="DELETE_FILE" />}
                message={<Langs str="DELETE_FILE_MSG" />}
                onDelete={handleDeleteConfirmed}
                onHide={() => setAssetToDelete(null)}
            />
        </div>
    )
}
